// Module
var code = "<wt-generic-search-bar class=\"fill\" criteria=\"vm.searchCriteria\" filtered-items=\"vm.filteredItems\" items=\"vm.items\" placeholder=\"Search (id:ID t:title u:user cat:category s:status)\"> </wt-generic-search-bar>";
// Exports
module.exports = code;